import script from "./ApiGoodsDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApiGoodsDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./ApiGoodsDrawer.vue?vue&type=style&index=0&id=6f57f409&lang=scss"
import "./ApiGoodsDrawer.vue?vue&type=style&index=1&id=6f57f409&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f57f409"]])

export default __exports__